import { render, staticRenderFns } from "./ViewFeedback.vue?vue&type=template&id=3be642ce&"
import script from "./ViewFeedback.vue?vue&type=script&lang=ts&"
export * from "./ViewFeedback.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports